import { FC } from "react";
import { Container, Header } from "semantic-ui-react";
import { NavBar } from "./NavBar";

export const Home: FC = () => (
    <Container>
        <NavBar/>
        <Header as={"h1"}>Welcome to OptiSpend</Header>
    </Container>
)